<template>
  <div id="software">
     <div class="text">
        <p>一、实施目标</p>
        <p>资产盘点是对医院内所有固定资产的详细清点和记录。这一过程的主要目的是为了帮助医院全面了解其资产的当前状况，包括资产的数量、位置和状态。通过盘点，能够帮助医院识别并处理那些不再使用或已经损坏的资产，即所谓的呆账和死数据。这不仅有助于保持资产台账的准确性和实时性，而且对于确保资产设备数据的及时更新和准确性至关重要，从而保证了资产信息的鲜活性和可靠性。本方案依托我司“芯医工-医疗设备全生命周期管理系统”实现。</p>
        <div class="flex">
          <img
            src="@/assets/images/20250724/ruanjian/pandian.png"
            style="width: 100%;"
            alt=""
          />
        </div>
        <p>二、实施计划</p>
        <p>1、前期筹备阶段（第1个自然日）</p>
        <p>制定盘点计划：明确盘点时间、地点、参与人员及职责分工。采购标签打印设备：根据盘点需求，采购相应的标签打印机用于现场打印标签。设备调试：确保所有标签打印设备正常运行，并进行现场测试。</p>
        <p>2、资产盘点（第2-90个自然日）</p>
        <p>（1）设备信息采集与录入 </p>
        <p>时间安排：根据设备数量，合理安排信息采集时间，确保在规定时间内完成。</p>
        <p>质量控制：设立审核机制，对录入的信息进行逐项审核，确保准确性。</p>
        <p>（2）设备标签生成与打印</p>
        <p>时间安排：在信息录入完成后，立即进行标签生成与打印。</p>
        <p>质量控制：检查打印出的设备标签，确保无损坏、污渍等问题。</p>
        <p>（3）设备标签粘贴与盘点</p>
        <p>时间安排：在标签打印完成后，立即进行粘贴和盘点。</p>
        <p>质量控制：设立监督人员，对标签粘贴和盘点过程进行监督，确保操作规范。</p>
        <p>3、数据标准化（第90-110个自然日）</p>
        <p>（1）时间安排：数据核对完成后，需要对特殊的资产进行标准化，如医疗设备，需要按照最新的医疗器械分类目录进行数据标准化。</p>
        <p>（2）质量控制：利用系统的设备分类标准化库，确保每个标准化的人员都能够对同类设备同样的数据标准化，确保数据的一致性。</p>
        <p>4、后期处理阶段（第110-120个自然日）</p>
        <p>（1）数据汇总与分析</p>
        <p>时间安排：盘点结束后，立即进行数据汇总和分析。</p>
        <p>质量控制：对汇总的数据与医院多次审核，确保无误。</p>
        <p>（2）异常处理与信息更新</p>
        <p>时间安排：在数据汇总分析完成后，及时处理异常数据，更新设备档案。</p>
        <p>质量控制：对处理结果进行跟踪，确保问题得到妥善解决。</p>
      </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution4.vue